var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    { staticClass: "page" },
    [
      _c("page-title", {
        attrs: {
          title: _vm.title,
          "sub-title": _vm.subTitle,
          "logo-src": _vm.logoSrc,
          "logo-alt": _vm.logoAlt,
        },
      }),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container" }, [_vm._t("default")], 2),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }